import React, {useState, useContext, useEffect, useRef, useCallback} from 'react';
import { useHistory } from 'react-router-dom'

import ChatModal from '../components/common/ChatModal';
import { DataContext } from '../context/DataContext';
import ChatGroupSvg from '../svg/ChatGroupSvg';
import SendBtnSvg from '../svg/SendBtnSvg';
import AttachmentSvg from '../svg/AttachmentSvg';
import ChatCard from '../components/ChatCard';
import Textarea from '../components/common/TextArea';
import getTime from '../components/common/getTime';
import { DropDocs, DropVideo, DropImage, DropAudio } from '../components/ChatFileInput';
import { toTitleCase } from '../util/titleCase';
import ChatLanding from './ChatLanding';
import defaultPic from '../images/defaultPic.png';
import FormError from '../components/common/FormError';
import loadingSpin from '../images/loadingSpin.gif';

import classNames from 'classnames';
import io from "socket.io-client";
import axios from 'axios';

const ChatPage = () => {
    const dataContext = useContext(DataContext);
    const history = useHistory()
    const [chatMessage, setChatMessage] = useState("");
    const [showInputBar, setShowInputBar] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [imageUpload, setImageUpload] = useState();
    const [videoUpload, setVideoUpload] = useState();
    const [audioUpload, setAudioUpload] = useState();
    const [docUpload, setDocUpload] = useState();
    const [imgUrl, setImgUrl] = useState({});
    const [uploadType, setUploadType] = useState('');
    const [loadingUpload, setLoadingUpload] = useState(false);
    const [uploadFalseMsg, setUploadFalseMsg] = useState('');

    const groupName = dataContext.groupName;
    const groupId = dataContext.clickedGroupId;

    const chatHistory = dataContext.chats;
    console.log(chatHistory); 
    let clickedGroup = chatHistory.filter(chat => chat.groupId === dataContext.clickedGroupId)[0];
    console.log(clickedGroup)
    const server = "https://edves-socket-api.herokuapp.com";
    // const server = "http://localhost:8080";
    const socket = io(server, {
        // withCredentials: true,
        // extraHeaders: {
        //   "my-custom-header": "abcd"
        // }
    });

    const schoolDomain = localStorage.getItem('schoolDomain');
    const studentInfo = JSON.parse(localStorage.getItem('studentInfo'));

    const admissionnumber = studentInfo[0].admissionnumber;
    const studentId = studentInfo[0].studentId;
    const firstname = toTitleCase(studentInfo[0].firstname);
    const surname = toTitleCase(studentInfo[0].surname);
    const name = `${firstname}${" "}${surname}`;
    const image = studentInfo[0].studentpassport;
    const time = getTime();

    const msgRef = useRef(null);
    const location = window.location.href
    const browserWidth = window.innerWidth
    
    useEffect(() => {
        if (browserWidth > '640' && location.substring(location.length - 8) !== 'chatroom') history.push('chatroom')
        console.log(browserWidth)
    },[browserWidth])

    useEffect(() => {

        if(msgRef && msgRef.current) {
            console.log(msgRef.current)
          const element = msgRef.current;
          element.scroll({
            top: element.scrollHeight,
            left: 0,
            behavior: "smooth"
          })
        }
  
    }, [msgRef, chatHistory]);

    const submitMsg = () => {
        if (chatMessage === '') return;

        socket.emit("Input Chat Message", {
            message: chatMessage,
            studentId,
            groupId,
            image : defaultPic,
            profilePix: image,
            // image,
            name,
            time,
            userName: name,
            admissionnumber,
            SchoolUrl : schoolDomain
        });
             
        setChatMessage('');
    };

    useEffect(() => {
        
        socket.on("Output Chat Message", messageFromBackEnd => {
            console.log( messageFromBackEnd);
            dataContext.setMessageFromBackEnd(messageFromBackEnd)
            dataContext.setChats(chats => {
                const found = chats.filter(chat => chat.groupId === messageFromBackEnd.groupId)[0];
                const foundChats = found && found.chats
                console.log(found)
                return chats.map(chat => chat.groupId === found.groupId ? {...chat, chats : [...foundChats, messageFromBackEnd]}: chat )
            })
            console.log(dataContext.chats);
        });
        return () => null

    }, []);

    const ImageModalBody = () => {
        return (
            imageUpload ?  (
                <div className='my-4'>
                    {uploadFalseMsg  && <FormError text = {uploadFalseMsg} />}
                    <img src={imageUpload} alt='preview' className='object-cover' />
                </div>
            ) :
            videoUpload ?  (
                <div className='my-4'>
                    {uploadFalseMsg && <FormError text = {uploadFalseMsg} />}
                    <video src={videoUpload} controls alt='preview' className='object-cover' />
                </div>
            ) :
            audioUpload ? (
                <div className='my-4'>
                    {uploadFalseMsg === false && <FormError text = {uploadFalseMsg} />}
                    <div className="flex justify-center items-center w-full mx-auto mt-6 cursor-pointer p-2 mb-2 text-gray-100 text-xs font-medium rounded border border-gray-500">
                        <span className="mr-2"> {audioUpload} </span>
                    </div>                
                </div>
            ) :
            docUpload ? (
                <div className='my-4'>
                    {uploadFalseMsg && <FormError text = {uploadFalseMsg} />}
                    <div className="flex justify-center items-center w-full mx-auto mt-6 cursor-pointer p-2 mb-2 text-gray-100 text-xs font-medium rounded border border-gray-500">
                        <span className="mr-2"> {docUpload} </span>
                    </div>                
                </div>
            ) : ''
        )
    };

    const uploadImg = async (imgFile) => {
        setUploadFalseMsg('')
        const queryData = new FormData();
        queryData.append("SchoolUrl", schoolDomain);
        queryData.append("uploadType", "chat");
        queryData.append("file[]", imgFile[0]);

        try {
            setLoadingUpload(true);
            const { data } = await axios.post(`/student/testupload`, queryData);
            console.log(data.status, data)
            if(!data.status) {
                setLoadingUpload(false);
                setUploadFalseMsg('Upload failed, please try again later');
                console.log(uploadFalseMsg);
            } else {
                setImgUrl(data.data.Message[0].fileUrl);
                setLoadingUpload(false)
                console.log(data.data.Message[0])
            }
        } catch (error) {
            setLoadingUpload(false)
            setUploadFalseMsg('Upload failed, please try again later')
            console.log(error)
        };
        
    }
    
    const onDropImg = useCallback(acceptedFiles => {
        console.log(acceptedFiles);
        uploadImg(acceptedFiles);
        const reader = new FileReader();
        
        acceptedFiles.map(file => {
            reader.onloadend = function(e) {
                console.log(e.target.result)
                setImageUpload(
                  e.target.result 
                );
            };
            reader.readAsDataURL(file);
            
            return file
        })
        setShowModal(true);
        setShowInputBar(false);
        
    }, []);
    
    const onDropVid = useCallback(acceptedFiles => {
        console.log(acceptedFiles);
        uploadImg(acceptedFiles);
        setUploadType('isVideo');

        const reader = new FileReader();
        acceptedFiles.map(file => {
            reader.onloadend = function(e) {
                console.log(e.target.result)
                setVideoUpload(
                  e.target.result 
                );
            };
            reader.readAsDataURL(file);
            
            return file
        })
        setShowModal(true);
        setShowInputBar(false)
    }, []);

    const onDropAudio = useCallback(acceptedFiles => {
        console.log(acceptedFiles);
        uploadImg(acceptedFiles);
        setAudioUpload(acceptedFiles[0].name);
        setUploadType('isAudio');
        setDocUpload('');
        setVideoUpload('');
        setImageUpload('');
        setShowModal(true);
        setShowInputBar(false);
    }, []);

    const onDropDoc = useCallback(acceptedFiles => {
        console.log(acceptedFiles);
        uploadImg(acceptedFiles);
        setDocUpload(acceptedFiles[0].name);
        setUploadType('isDoc');
        setAudioUpload('');
        setVideoUpload('');
        setImageUpload('')
        setShowModal(true);
        setShowInputBar(false);
    }, []);

    const submitImgMsg = () => {
        // if (imageUpload === '') return;

        socket.emit("Input Chat Message", {
            message: imgUrl,
            groupId,
            studentId,
            admissionnumber,
            SchoolUrl : schoolDomain,
            image : defaultPic,
            profilePix: defaultPic,
            name,
            time,
            userName: name,
            messagetype : uploadType === 'isVideo' ? 'video' : uploadType === 'isDoc' ? 'doc' : uploadType === 'isAudio' ? 'audio' : 'image'
        });
        setDocUpload('');
        setVideoUpload('');
        setAudioUpload('')
        setImageUpload('');

        setUploadType('');
        setImgUrl('');
        setShowModal(false);
    };

    dataContext.clickedGroupId &&  console.log(dataContext.clickedGroupId);

    const sendMsg = {
        disableBtn : uploadFalseMsg === 'Upload failed, please try again later' ? true : false,
        loading : loadingUpload,
        text: uploadType === 'isVideo' ? 'Send Video' : uploadType === 'isDoc' ? 'Send Document' : uploadType === 'isAudio' ? 'Send Audio' : 'Send Image',
        onClick: () => submitImgMsg()
    };

    const whiteBtnAttr = {
        text: 'Cancel',
        onClick: () => {setUploadType('');setShowModal(false)}
    }

    const ImgTitle = () => (
        <span className="text-gray-100"> {imageUpload ? 'Attach Image' : videoUpload ? 'Attach Video' : audioUpload ? 'Attach Audio' : docUpload ? 'Attach Document' : ''} </span>
    );

    const showModalStyling = classNames({
        "border-0 rounded-lg shadow-lg w-2/5 p-8 relative flex flex-col mx-auto bg-white outline-none focus:outline-none" : true
    });

    return (
        <>
            {
                dataContext.clickedGroupId ? 
            <div className='sm:w-3/4  sm:ml-16'>
                <div className='sm:h-full sm:pt-2'>
                    {showModal && 
                    <ChatModal Body={ImageModalBody} BtnAttr={sendMsg} whiteBtnAttr={whiteBtnAttr}  closeModal={() => setShowModal(false)} Title={ImgTitle} modalStyling={showModalStyling} />
                    }
                    <div className='sm:rounded-lg sm:shadow-lg sm:bg-white h-full w-full'>
                        <div className='h-full px-2 relative'>
                            <div className='h-full hover:overflow-y-auto overflow-x-hidden'>
                                <div className='flex items-center px-2 sm:px-8 py-4 sm:py-4 border-b border-gray-600'>
                                    <span className='mr-3'>
                                        <ChatGroupSvg />
                                    </span>
                                    <span className='text-gray-200 text-sm leading-5 font-bold'> {groupName ? groupName : "Click a Group to Begin"} </span>
                                </div>
                                <div ref={msgRef} className='chatPageHeight sm:mb-4'>
                                    {clickedGroup && clickedGroup.chats !== undefined ? clickedGroup.chats
                                    // chatHistory ? chatHistory.filter(chat => chat.groupId === dataContext.clickedGroupId).chats
                                    .map(chat => {
                                        return <ChatCard key={chat.messageId} {...chat} />
                                    }) : 
                                        <img src={loadingSpin} className='mx-auto mt-16' alt='loading...' />
                                    }
                                    <div
                                        ref = {msgRef}
                                        style={{ float: "left", clear: "both" }}
                                    />
                                </div>
                            </div>
                            {showInputBar && 
                                <div className='Lgcontainer flex justify-center items-center absolute right-0 bottom-0'>
                                    <div className='w-full sm:w-1/2 ml-16  bg-white border border-gray-600 rounded-md'>
                                        <div className='flex justify-around w-full py-4 z-50'>
                                            <div className='flex flex-col justify-center items-center'>
                                                <div className='cursor-pointer'>
                                                    <DropDocs onDrop={onDropDoc} accept={".doc,.docx,.xml,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,.pdf"} />
                                                </div>
                                            </div>
                                            <div className='flex flex-col justify-center items-center'>
                                                <div className='cursor-pointer'>
                                                    <DropImage onDrop={onDropImg} accept={"image/*"} />
                                                </div>
                                            </div>
                                            <div className='flex flex-col justify-center items-center'>
                                                <div className='cursor-pointer'>
                                                    <DropVideo onDrop={onDropVid} accept={"video/*"} />
                                                </div>
                                            </div>
                                            <div className='flex flex-col justify-center items-center'>
                                                <div className='cursor-pointer'>
                                                    <DropAudio onDrop={onDropAudio} accept={"audio/*"} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
                <div className='submitHmwrkShadow  sm:mb-1 w-full'>
                    <div className='flex mt-0 sm:-mt-1 w-full py-2 px-2 sm:px-8'>
                        <div className='mr-2 w-10/12'>
                            <Textarea 
                                name='message'
                                type='text' 
                                // className='whitespace-pre-wrap'
                                value={chatMessage}
                                onChange={(e)=> setChatMessage(e.target.value)}
                            />
                        </div>
                        <span onClick={()=> setShowInputBar(!showInputBar)} className='w-5 m-auto mr-2 cursor-pointer'>
                            <AttachmentSvg />
                        </span>
                        <span onClick={submitMsg} className='w-6 m-auto cursor-pointer'>
                            <SendBtnSvg />
                        </span>
                    </div>
                </div>
            </div> :
            <div className='hidden sm:block w-3/4 h-screen py-4 ease-in transition-transform sm:ml-16'>
                <ChatLanding />
            </div>
            }
        </>
        )
}

export default ChatPage;